import React, { useState, useEffect } from 'react';
import { TextField } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import CustomSchema from '@/schema/CustomSchema';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers';
import { FormProvider } from 'react-hook-form';
import LoadingPanel from '@/component/common/LoadingPanel';
import ErrorMessageHeader from '../common/ErrorMessageHeader';
import '../common/ErrorMessageHeader.css';
import ButtonSubmitAddTicket from './ButtonSubmitAddTicket';

import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import { FormControl } from '@material-ui/core';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { userAtom } from '@/state/atom/userAtom';
import { projectInuseDetailAtom } from '@/state/atom/projectAtom';
import { corporationAtom } from '@/state/atom/corporationAtom';
import { multiPanelAtom, panelSettingAtom, panelStartIndexAtom } from '@/state/atom/panelAtom';
import { formListOfProjectSelector } from '@/state/selector/formSelector' ;
import {
    getFormFromFormListById,
    getListCustomFiledOfForm,
    unregisterField,
} from './handler/TicketHandler';
import {
    getFormFieldData,
    getListMasterKnowledgeFormOfProject,
} from '../common/layout/addTicket/handler/AddTicketHandler';
import RenderFieldUI from '../formManagement/RenderFieldUI';
import { updatePanelAfterCreateTicketSelector } from '@/state/selector/panelSelector';
import { createMasterKnowledgeTicketHandler } from './handler/MasterKnowledgeTicketHandler';

export default function MasterKnowledgeTicket(props) {
    const panelChildren = window.innerWidth > 991 ? 3 : 1;
    const [panelList, setPanelList] = useRecoilState(multiPanelAtom);
    const [currentIndex, setCurrentIndex] = useRecoilState(panelStartIndexAtom);
    const [settingSlide, setSettingSlide] = useRecoilState(panelSettingAtom);
    const [isExChangeTagField, setIsExChangeTagField] = useState(false)
    const [listFieldEdited, setListFieldEdited] = useState([])
    const [isLoading, setIsLoading] = useState(false);
    const [flagReset, setFlagReset] = useState(false);

    const [fileUploadList, setFileUploadList] = useState([]);

    const userDetail = useRecoilValue(userAtom);
    const projectInuseDetail = useRecoilValue(projectInuseDetailAtom);
    const corporationDetail = useRecoilValue(
        corporationAtom
    );
    const formList = useRecoilValue(formListOfProjectSelector);
    const [masterKnowledgeFormList, setMasterKnowledgeFormList] = useState(
        getListMasterKnowledgeFormOfProject(formList, projectInuseDetail.id, corporationDetail) || []
    );

    // state of formList
    const [isErrorSelected, setIsErrorSelected] = useState(false);
    const [fieldListData, setFiledListData] = useState([]);
    const [selectedForm, setSelectedForm] = useState('');
    const [selectedPublicRange, setSelectedPublicRange] = useState(
        Constant.KNOWLEDGE_PUBLIC_RANGE.ONLY_ME
    );
    const [errorMessageHeader, setErrorMessageHeader] = useState('');

    const validateCreateMasterKnowledgeTicket = useForm({
        mode: 'all',
        resolver: yupResolver(CustomSchema(fieldListData)),
    });
    const handleSubmitCreateMasterKnowledgeTicket = validateCreateMasterKnowledgeTicket.handleSubmit;
    const errorCreateMasterKnowledgeTicket = validateCreateMasterKnowledgeTicket.errors;
    const unregisterCreateMasterKnowledgeTicket = validateCreateMasterKnowledgeTicket.unregister;
    const setValueCreateMasterKnowledgeTicket = validateCreateMasterKnowledgeTicket.setValue;
    const registerCreateMasterKnowledgeTicket = validateCreateMasterKnowledgeTicket.register;
    const clearErrors = validateCreateMasterKnowledgeTicket.clearErrors;
    const triggerValidate = validateCreateMasterKnowledgeTicket.trigger;

    const argsAll = {
        panelChildren,
        panelList,
        currentIndex,
        settingSlide,
        setIsLoading,
        setPanelListRecoilState: setPanelList,
        setCurrentIndex,
        setSettingSlide,
        API: props?.API,

        formList: formList,
        projectInuseDetail: projectInuseDetail,
        masterKnowledgeFormList: masterKnowledgeFormList,
        setMasterKnowledgeFormList: setMasterKnowledgeFormList,

        isErrorSelected: isErrorSelected,
        setIsErrorSelected: setIsErrorSelected,

        selectedForm: selectedForm,
        setSelectedForm: setSelectedForm,

        fieldListData,
        setFiledListData,

        selectedPublicRange,
        setSelectedPublicRange,

        errorMessageHeader,
        setErrorMessageHeader,

        updatePanelAfterCreateTicket: useSetRecoilState(updatePanelAfterCreateTicketSelector),

        flagReset,
        setFlagReset
    };

    useEffect(() => {
        validateCreateMasterKnowledgeTicket.reset();
        validateCreateMasterKnowledgeTicket.register('fileUploadList');
        validateCreateMasterKnowledgeTicket.register('publicRange');
        setValueCreateMasterKnowledgeTicket('publicRange', Constant.KNOWLEDGE_PUBLIC_RANGE.ONLY_ME);
    }, []);

    const onSubmitCreateMasterKnowledgeTicket = (formData) => {
        return createMasterKnowledgeTicketHandler(
            props.tabId,
            props.panelType,
            formData,
            userDetail,
            corporationDetail,
            props.panelId,
            argsAll,
            fieldListData
        );
    };

    const handleOnchangeForm = async (e) => {
        setIsErrorSelected(false);
        if (e.target.value === selectedForm) {
            return;
        }

        setIsLoading(true);
        if (!Utils.isEmptyArray(fieldListData)) {
            unregisterField(fieldListData, unregisterCreateMasterKnowledgeTicket);
        }
        setSelectedForm(e.target.value);

        setValueCreateMasterKnowledgeTicket('selectedForm', e.target.value);
        const selectedFormDetail = await getFormFromFormListById(e.target.value);
        if (!Utils.isEmptyObject(selectedFormDetail)) {
            const formStructure = JSON.parse(selectedFormDetail?.structure);
            const customFieldList = await getListCustomFiledOfForm(
                formStructure,
                props?.API,
                selectedFormDetail.affiliationOrganization
            );
            let getFieldListResult = getFormFieldData(formStructure, customFieldList);
           getFieldListResult = Array.from(getFieldListResult,(field) => {
                field.structure.publicForCustomer = 3
                return field
            })
            setFiledListData([...getFieldListResult]);
        }
        setIsLoading(false);
    };

    const handleOnchangePublicRange = (e) => {
        let newPublicRange = e.target.value;
        if (newPublicRange === selectedPublicRange) {
            return;
        }
        setSelectedPublicRange(newPublicRange);
        setValueCreateMasterKnowledgeTicket('publicRange', newPublicRange);
    };

    return (
        <div className="groupCreate-main">
            <LoadingPanel isLoading={isLoading} />
            <FormProvider {...validateCreateMasterKnowledgeTicket}>
                <FormControl className="formControl">
                    {/* btn submit */}
                    <ButtonSubmitAddTicket
                        onClick={handleSubmitCreateMasterKnowledgeTicket(onSubmitCreateMasterKnowledgeTicket)}
                        ticketType={Constant.TICKET_TYPE.KNOWLEDGE}
                        isEdited={false}
                    />

                    {/* form data */}
                    <div className='groupKnow'>
                        <div className="heade-create">
                            {/* select form */}
                            <div className='heade-createForm'>
                                <div className="headeForm">
                                    <div className="headeTitle">フォーマット</div>
                                    <div className="headeInfo">
                                        <div className="headeSelect">
                                            <TextField
                                                className="form-control--wrap form-control--hg40"
                                                select
                                                variant="outlined"
                                                name="selectedForm"
                                                value={selectedForm}
                                                onChange={handleOnchangeForm}
                                                required
                                                // error
                                                SelectProps={{
                                                    MenuProps: {
                                                    anchorOrigin: {
                                                        vertical: "bottom",
                                                        horizontal: "left"
                                                    },
                                                    getContentAnchorEl: null,
                                                    className: "selectDrop"
                                                    }
                                                }}
                                            >
                                                {!Utils.isEmptyArray(masterKnowledgeFormList) &&
                                                    masterKnowledgeFormList.map((item) => {
                                                        return (
                                                            <MenuItem key={item.id} value={item.id}>
                                                                {Utils.getTextByLanguage(
                                                                    Constant.LANGUAGE_TYPE.JP,
                                                                    item.name
                                                                )}
                                                            </MenuItem>
                                                        );
                                                    })}
                                            </TextField>
                                        </div>
                                    </div>
                                </div>

                                {/* select public range */}
                                <div className="headeForm">
                                    <div className="headeTitle">公開範囲</div>
                                    <div className="headeInfo">
                                        <div className="headeSelect">
                                            <TextField
                                                className="form-control--wrap form-control--hg40"
                                                select
                                                variant="outlined"
                                                name="publicRange"
                                                value={selectedPublicRange}
                                                onChange={(e) => handleOnchangePublicRange(e)}
                                                required
                                                defaultValue={Constant.KNOWLEDGE_PUBLIC_RANGE.ONLY_ME}
                                                SelectProps={{
                                                    MenuProps: {
                                                    anchorOrigin: {
                                                        vertical: "bottom",
                                                        horizontal: "left"
                                                    },
                                                    getContentAnchorEl: null,
                                                    className: "selectDrop"
                                                    }
                                                }}
                                            >
                                                <MenuItem
                                                    key={Constant.KNOWLEDGE_PUBLIC_RANGE.ONLY_ME}
                                                    value={Constant.KNOWLEDGE_PUBLIC_RANGE.ONLY_ME}
                                                >
                                                    自分のみ
                                                </MenuItem>
                                                <MenuItem
                                                    key={Constant.KNOWLEDGE_PUBLIC_RANGE.PROJECT_ONLY}
                                                    value={Constant.KNOWLEDGE_PUBLIC_RANGE.PROJECT_ONLY}
                                                >
                                                    プロジェクト内
                                                </MenuItem>
                                                <MenuItem
                                                    key={
                                                        Constant.KNOWLEDGE_PUBLIC_RANGE.CORPORATION_ONLY
                                                    }
                                                    value={
                                                        Constant.KNOWLEDGE_PUBLIC_RANGE.CORPORATION_ONLY
                                                    }
                                                >
                                                    組織内
                                                </MenuItem>
                                                <MenuItem
                                                    key={Constant.KNOWLEDGE_PUBLIC_RANGE.ALL}
                                                    value={Constant.KNOWLEDGE_PUBLIC_RANGE.ALL}
                                                >
                                                    組織外
                                                </MenuItem>
                                            </TextField>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="scrollBar-main">
                            <div className="addTicket">
                                <ErrorMessageHeader message={errorMessageHeader} />
                                {!Utils.isEmptyArray(fieldListData) &&
                                    fieldListData
                                        ?.filter((field) => field.type !== 'WORKFLOW')
                                        .map((fieldData, i) => (
                                            <RenderFieldUI
                                                key={i}
                                                API={props?.API}
                                                UI={fieldData.structure.UI}
                                                label={
                                                    fieldData.fieldLabel
                                                        ? Utils.getTextByLanguage(
                                                            Constant.LANGUAGE_TYPE.JP,
                                                            fieldData.fieldLabel
                                                        )
                                                        : ''
                                                }
                                                errorlist={errorCreateMasterKnowledgeTicket}
                                                name={fieldData.fieldId}
                                                data={fieldData}
                                                triggerValidate={triggerValidate}
                                                // Drop file props
                                                fileUploadList={fileUploadList}
                                                setFileUploadList={setFileUploadList}
                                                register={registerCreateMasterKnowledgeTicket}
                                                setValue={setValueCreateMasterKnowledgeTicket}
                                                clearErrors={clearErrors}
                                                isExChangeTagField={isExChangeTagField}
                                                setIsExChangeTagField={setIsExChangeTagField}
                                                listFieldEdited ={listFieldEdited} 
                                                setListFieldEdited ={setListFieldEdited}
                                                detailTicket={props?.detailTicket}
                                                isLoading={isLoading}
                                                setIsLoading={setIsLoading}
                                                flagReset={flagReset}
                                                setFlagReset={setFlagReset}
                                                isDisplaySplitPdfSwitch={Utils.isDisplaySplitPdfSwitch(corporationDetail)}
                                                isShowIconCopyFieldId={false}
                                            />
                                        ))}
                            </div>
                        </div>
                    </div>
                </FormControl>
            </FormProvider>
        </div>
    );
}
